//
//
//
//

export default {
  props: {
    task: Promise,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    task(task) {
      this.isLoading = false;
      if (task) {
        this.isLoading = true;
        task.finally(() => {
          this.isLoading = false;
        });
      }
    },
  },
};
